import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {format} from 'date-fns';
const {FiActivity,FiClock,FiWifi,FiWifiOff}=FiIcons;
const Header=({lastUpdate,isOnline,isLoading})=> {
const formatTime=(date)=> {
if (!date) return 'Never';
return format(new Date(date),'MMM dd,yyyy HH:mm:ss') + ' PHT';
};
return (
<header className="bg-white border-b border-gray-200 px-4 py-4">
<div className="max-w-7xl mx-auto flex items-center justify-between">
<div className="flex items-center space-x-3">
<motion.div animate={{rotate: isLoading ? 360 : 0}} transition={{duration: 1,repeat: isLoading ? Infinity : 0,ease: "linear"}} >
<SafeIcon icon={FiActivity} className="text-2xl text-blue-600" />
</motion.div>
<div>
<h1 className="text-xl font-bold text-gray-900">
Iligan Disaster Risk Portal
</h1>
<p className="text-sm text-gray-600"> Multi-hazard monitoring dashboard </p>
</div>
</div>
<div className="flex items-center space-x-4">
<div className="flex items-center space-x-2 text-sm">
<SafeIcon icon={FiClock} className="text-gray-500" />
<div className="text-right">
<div className="text-gray-900 font-medium"> Last Updated </div>
<div className="text-gray-600"> {formatTime(lastUpdate)} </div>
</div>
</div>
<div className="flex items-center space-x-2">
<SafeIcon icon={isOnline ? FiWifi : FiWifiOff} className={`text-lg ${isOnline ? 'text-green-500' : 'text-red-500'}`} />
<span className={`text-sm font-medium ${isOnline ? 'text-green-600' : 'text-red-600'}`}>
{isOnline ? 'Online' : 'Offline'}
</span>
</div>
</div>
</div>
</header>
);
};
export default Header;